import { useAuth0 } from '@auth0/auth0-react'
import {
  Flex,
  Box,
  Heading,
  Text,
  Avatar,
  useMediaQuery,
  Modal,
  ModalOverlay,
  ModalContent,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  Button,
  VStack,
  useToast
} from '@chakra-ui/react'
import { FC, useCallback, useState } from 'react'
import { decodeToken } from 'react-jwt'

import useUserData from '@hook/shared/use-userdata'

const HeaderProfile: FC = () => {
  const { user: userAuth } = useAuth0()

  const { user } = useUserData()
  const toast = useToast()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isLargerThanHD, isDisplayingInBrowser] = useMediaQuery([
    '(min-width: 480px)',
    '(display-mode: browser)'
  ])
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE
  const userInfos = JSON.parse(
    localStorage.getItem(
      `@@auth0spajs@@::${clientId}::${audience}::openid profile email offline_access`
    )
  )
  const decodedToken = decodeToken(userInfos?.body.access_token) as any

  const handleClearCache = useCallback(async () => {
    try {
      localStorage.clear()
      sessionStorage.clear()

      if ('caches' in window) {
        const cacheNames = await caches.keys()
        await Promise.all(cacheNames.map(name => caches.delete(name)))
      }

      const cookies = document.cookie.split(';')
      for (const cookie of cookies) {
        const name = cookie.split('=')[0].trim()
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`
      }

      toast({
        title: 'Cache limpo',
        description: 'Recarregando a pagina...',
        status: 'success',
        duration: 1500,
        isClosable: false,
        position: 'bottom-right'
      })

      setTimeout(() => {
        window.location.reload()
      }, 1500)
    } catch {
      window.location.reload()
    }
  }, [toast])

  return (
    <Flex alignItems="center" justifyContent="flex-start" position="relative">
      <Avatar
        name={
          userAuth
            ? userAuth?.nickname
                ?.replace('Consultor - ', '')
                .split(' ')
                .slice(0, 2)
                .join(' ')
            : 'John Doe'
        }
        position="relative"
        bgColor="yellow.400"
        color="green.600"
        borderRadius="8px"
        height={['2.2rem', '2.5rem', '2.5rem']}
        width={['2.2rem', '2.5rem', '2.5rem']}
        onClick={() =>
          !isLargerThanHD && isDisplayingInBrowser && setIsModalOpen(true)
        }
        cursor={!isLargerThanHD && isDisplayingInBrowser && 'pointer'}
      />

      <Popover placement="bottom-end">
        <PopoverTrigger>
          <Box
            ml={2}
            textAlign="left"
            display={['none', 'block', 'block']}
            cursor="pointer"
            _hover={{ opacity: 0.8 }}
          >
            <Heading size="sm">
              Olá,{' '}
              {decodedToken?.nameid !== null
                ? decodedToken?.nameid
                : userAuth?.nickname}
              !
            </Heading>
            <Text fontSize="xs" maxW="160px" isTruncated>
              {userAuth ? userAuth?.email : 'johndoe@provider.domain'}
            </Text>
          </Box>
        </PopoverTrigger>
        <PopoverContent width="200px" borderRadius="8px" boxShadow="lg">
          <PopoverBody p={2} bg="white">
            <VStack spacing={1} align="stretch">
              <Button
                size="sm"
                variant="ghost"
                justifyContent="flex-start"
                fontWeight="normal"
                color="black"
                bg="white"
                _hover={{ bg: 'gray.100' }}
                onClick={handleClearCache}
              >
                Limpar Cache
              </Button>
            </VStack>
          </PopoverBody>
        </PopoverContent>
      </Popover>

      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <ModalOverlay />

        <ModalContent
          top={-3}
          right={0}
          width={175}
          background={'white'}
          transition="all ease .1s"
          padding={2}
          left="calc((100vw - 50%) - 104px)"
        >
          <Heading size="sm">
            Olá,{' '}
            {user
              ? user.profile.given_name
                  ?.replace('Consultor - ', '')
                  .split(' ')
                  .slice(0, 2)
                  .join(' ')
              : 'John Doe'}
            !
          </Heading>
          <Text fontSize="xs" maxW="160px" isTruncated>
            {userAuth ? userAuth?.email : 'johndoe@provider.domain'}
          </Text>
        </ModalContent>
      </Modal>
    </Flex>
  )
}

export default HeaderProfile
